(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clone-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fogwell-header-icons')){
customElements.define('fogwell-header-icons',class extends HTMLElement{
connectedCallback(){
this.controller?.abort();this.controller=new AbortController();
const options={signal:this.controller.signal};
for(const link of this.querySelectorAll('a')){
const reset=()=>{link.style.removeProperty('--icon-x');link.style.removeProperty('--icon-y')};
link.addEventListener('pointermove',event=>{
if(event.pointerType!=='mouse'||matchMedia('(prefers-reduced-motion:reduce)').matches)return;
const rect=link.getBoundingClientRect();
link.style.setProperty('--icon-x',((event.clientX-rect.left-rect.width/2)*.22)+'px');
link.style.setProperty('--icon-y',((event.clientY-rect.top-rect.height/2)*.22)+'px');
},options);
link.addEventListener('pointerleave',reset,options);
link.addEventListener('pointercancel',reset,options);
link.addEventListener('blur',reset,options);
}}
disconnectedCallback(){this.controller?.abort()}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clone-main-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    root.querySelectorAll('.fogwell-pdp').forEach(section => {
      if (section.dataset.motionBound) return;
      section.dataset.motionBound = 'true';
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const thumbs = [...section.querySelectorAll('[data-media]')];
      thumbs.forEach(button => button.addEventListener('click', () => {
        thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
        section.querySelectorAll('[data-media-panel]').forEach(panel => {
          if (panel.dataset.mediaPanel !== button.dataset.media) {
            panel.querySelectorAll('video').forEach(video => video.pause());
            return;
          }
          if (!reduce.matches) {
            panel.getAnimations().forEach(animation => animation.cancel());
            panel.animate([{opacity: .25, transform: 'translateY(8px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 450, easing: 'cubic-bezier(.3,1,.3,1)'});
          }
        });
      }));
      section.querySelectorAll('.clone-product-accordions details').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open && !reduce.matches) details.querySelector('div').animate([{opacity: 0, transform: 'translateY(-6px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 300, easing: 'ease-out'});
        });
      });
      section.querySelectorAll('[data-size-link]').forEach(button => button.addEventListener('click', () => {
        const details = document.getElementById(button.dataset.sizeLink);
        if (!details) return;
        details.open = true;
        details.scrollIntoView({behavior: reduce.matches ? 'instant' : 'smooth', block: 'center'});
        details.querySelector('summary').focus({preventScroll: true});
      }));
      const quantity = section.querySelector('[name="quantity"]');
      const decrement = section.querySelector('[data-qty="-1"]');
      const stock = section.querySelector('[data-stock]');
      const sync = () => {
        if (decrement) decrement.disabled = Number(quantity.value) <= Number(quantity.min || 1);
        if (stock) stock.classList.toggle('is-unavailable', section.querySelector('.clone-add').disabled);
      };
      section.addEventListener('change', sync);
      section.addEventListener('input', sync);
      section.querySelectorAll('[data-qty]').forEach(button => button.addEventListener('click', () => requestAnimationFrame(sync)));
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clone-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => root.querySelectorAll('.fogwell-reviews').forEach(section => {
    if (section.dataset.reviewBound) return;
    section.dataset.reviewBound = 'true';
    const details = section.querySelector('.fogwell-review-form');
    const openButton = section.querySelector('[data-open-review]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const open = () => {
      details.open = true;
      details.scrollIntoView({behavior:reduced.matches ? 'instant' : 'smooth',block:'center'});
      details.querySelector('input[type=radio]')?.focus({preventScroll:true});
    };
    openButton?.addEventListener('click', event => {event.preventDefault();open();});
    section.querySelector('[data-cancel-review]')?.addEventListener('click', () => {details.open = false;openButton.focus({preventScroll:true});openButton.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'center'});});
    details.addEventListener('toggle', () => {
      if (details.open && !reduced.matches) details.querySelector('.fogwell-review-fields').animate([{opacity:0,transform:'translateY(-10px)'},{opacity:1,transform:'translateY(0)'}],{duration:350,easing:'cubic-bezier(.3,1,.3,1)'});
    });
    if (location.hash === '#' + details.closest('form').id) details.open = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
